import * as React from "react"
import { AnimatePresence } from "framer-motion"
import Modal from "../../components/molecules/Modals/Modal"
import ReportPreview from "./ReportPreview"
import PrimaryButton from "../../components/atoms/buttons/PrimaryButton"
import SmallButton from "../../components/atoms/buttons/SmallButton"
import ReportSettingsModalContent from "./ReportSettingsModalContent"
import { ChartSettings } from "../../components/organisms/charts/SharedDataChartView"
import { Row } from "react-grid-system"

type Props = React.ComponentPropsWithoutRef<typeof ReportPreview> & { small?: boolean }

const ViewReportButton: React.FC<Props> = (props) => {
  const [exportModalIsOpen, setExportModalIsOpen] = React.useState(false)
  const [settingsModalIsOpen, setSettingsModalIsOpen] = React.useState(false)
  const [chartSettings, setChartSettings] = React.useState<ChartSettings>(props.options)

  const Button = props.small !== undefined ? SmallButton : PrimaryButton

  return (
    <>
      <Button title="View report" onClick={() => setSettingsModalIsOpen(true)} />
      <AnimatePresence initial={false} mode="wait" onExitComplete={() => null}>
        {exportModalIsOpen && (
          <Modal open={exportModalIsOpen} onClose={() => setExportModalIsOpen(false)} closeIcon fixedWidth={false}>
            <ReportPreview options={{ ...props.options, ...chartSettings }} />
          </Modal>
        )}
        {settingsModalIsOpen && (
          <Modal open={settingsModalIsOpen} onClose={() => setSettingsModalIsOpen(false)} closeIcon fixedWidth={false}>
            <ReportSettingsModalContent
              initial={props.options}
              onChange={setChartSettings}
              onClickShow={() => {
                setSettingsModalIsOpen(false)
                setExportModalIsOpen(true)
              }}
            />
          </Modal>
        )}
      </AnimatePresence>
    </>
  )
}

export default ViewReportButton
